import React, { useState } from 'react';
import { useMemo } from 'react';
import css from './Bottle.module.css';

export const RaterBottle = ({
  percentage,
  id,
  handleOnClick,
  handleOnMouseEnter,
  hanldeOnMouseLeave,
}) => {
  return (
    <div style={{ marginRight: '10px' }}>
      <svg
        width="7"
        height="20"
        viewBox="0 0 7 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={handleOnClick}
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={hanldeOnMouseLeave}
        style={{ cursor: 'pointer' }}
      >
        <linearGradient id={id} x1="0.5" y1="1" x2="0.5" y2="0">
          <stop offset="0%" stopOpacity="1" stopColor="#78264F" />
          <stop offset={`${percentage}%`} stopOpacity="1" stopColor="#78264F" />
          <stop offset="0%" stopColor="#f2f1ef" />
          <stop offset="100%" stopColor="#f2f1ef" />
        </linearGradient>
        <path
          d="M2.38649 0.375H4.61351V3.96478C4.61351 4.99951 4.91996 5.96052 5.52432 6.83953L5.52423 6.8396L5.52978 6.84725L5.84879 7.28707C6.36747 8.04304 6.625 8.88922 6.625 9.76722V19.625H0.375V9.76722C0.375 8.89132 0.631399 8.04337 1.15332 7.25003L1.47022 6.81312L1.47023 6.81312L1.47136 6.81154C2.08148 5.96113 2.38649 4.96271 2.38649 3.96478V0.375Z"
          fill={`url(#${id})`}
          stroke="#78264F"
          strokeWidth="0.75"
        />
      </svg>
    </div>
  );
};

const Rater = ({ score = 0, setScore, uniqId = 'rate' }) => {
  const [ratings, setRatings] = useState([]);
  const [click, setClick] = useState(false);

  useMemo(() => {
    let tempScore = [];
    for (let i = 1; i <= 5; i++) {
      let tempPercent;

      if (score >= 1) {
        tempPercent = 100;
      } else if (score <= 0) {
        tempPercent = 0;
      }
      tempScore = [
        ...tempScore,
        {
          percentage: tempPercent,
          uniqId: uniqId + '_' + Math.random() * 100 + '_' + i,
        },
      ];
      score--;
    }
    setRatings(tempScore);
  }, [score]);

  const handleOnClick = index => {
    setScore(index);
    setClick(true);
  };
  // const handleOnMouseEnter = index => {
  //   setScore(index);
  //   setClick(false);
  // };
  // const hanldeOnMouseLeave = () => {
  //   if(click) {
  //     setScore(score);
  //   } else {
  //     setScore(0);
  //   }
  //   setClick(false);
  // }

  return (
    <div style={{ display: 'flex' }}>
      {ratings.map((r, index) => {
        return (
          <RaterBottle
            handleOnClick={() => handleOnClick(index + 1)}
            // handleOnMouseEnter={() => handleOnMouseEnter(index + 1)}
            // hanldeOnMouseLeave={hanldeOnMouseLeave}
            key={index}
            percentage={r.percentage}
            id={r.uniqId}
          />
        );
      })}
    </div>
  );
};
export default Rater;

// const Rater = () => {
//     const [rating, setRating] = useState(null)
//     const [hover, setHover] = useState(null)
//     const [value] = useState(100)
//     const [iconValue, setIconValue] = useState(5)
//     const size = 100

//     return (
//         <div id="start-wrap">
//             <svg className="linear-gradient-template">
//                 <linearGradient id="orange_red" x1="0%" y1="0%" x2="100%" y2="0%">
//                     <stop offset="50%" style={{stopColor: 'rgb(255, 193, 7)'}}></stop>
//                     <stop offset="50%" style={{stopColor: 'rgb(228, 229, 233)'}}></stop>
//                 </linearGradient>
//             </svg>
//             <select onChange={(e) =>
//             {setIconValue(Number(e.target.value))}}>
//                 { Array.from(new Array(value),(value, index) =>
//                     index + 1).map(value => <option
//                     key={value} value={value}>{value}</option>) }
//             </select>
//             <h1> Select Amount of Icons </h1>
//             {[... Array(iconValue)].map((icon, i) => {
//                 const value = i + 1
//                 return (
//                     <label>
//                         <input type='radio'
//                             name='rating'
//                             value={value}
//                             onClick={() => setRating(value)}
//                         />
//                         <FaStar
//                             className='star'
//                             color={value <= (hover || rating) ? '#ffc107' : '#e4e5e9'}
//                             size={size}
//                             onMouseEnter={(e) => setHover(value)}
//                             onMouseLeave={() => {
//                                 let svgDom = document.getElementsByClassName('star')[i]
//                                 let pathDom = svgDom.children[0]
//                                 pathDom.style.fill = ''
//                                 setHover(null)
//                             }}
//                             onMouseMove={e => {
//                                 let svgDom = document.getElementsByClassName('star')[i]
//                                 let pathDom = svgDom.children[0]
//                                 if(e.pageX - svgDom.getBoundingClientRect().left <= size / 2){
//                                     pathDom.style.fill = 'url(#orange_red)'
//                                 } else {
//                                     pathDom.style.fill = ''
//                                 }
//                             }}
//                         />
//                     </label>
//                 )
//             })}
//         </div>
//     )
// }

// export default Rater
